import React from 'react';
import Card from '../shared/ui/Card';
import { theme } from '../shared/config/theme';

const plans = { mini: 'Mini', plus: 'Plus', pro: 'Pro', max: 'Max' };
const dateLabel = value => {
  const date = new Date(value);
  return value && Number.isFinite(date.getTime()) ? date.toLocaleString('ru-RU', {
    timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }) : 'Неизвестно';
};

export default function TrialUsersPanel({ users, onSelectUser }) {
  const trials = users.filter(user => user.is_trial_active === true)
    .sort((a, b) => (Date.parse(a.trial_end) || Infinity) - (Date.parse(b.trial_end) || Infinity));
  return <Card padding="lg">
    <section aria-labelledby="admin-trials-title">
      <h2 id="admin-trials-title" className="text-xl font-semibold" style={{ color: theme.text }}>Сейчас на пробном периоде</h2>
      <p className="text-sm mt-2 mb-5" style={{ color: theme.textSoft }}>
        Пробные подписки сайта, действующие и в приложении. Состояние на момент обновления, независимо от выбранного периода. Даты — МСК. Это не оплаченные подписки.
      </p>
      {trials.length === 0 ? <p className="text-sm" style={{ color: theme.textSoft }}>Сейчас нет пользователей на действующем пробном периоде.</p> :
        <div className="overflow-x-auto"><table className="min-w-full text-sm">
          <thead><tr style={{ color: theme.textSoft, borderBottom: `1px solid ${theme.border}` }}>
            <th className="text-left py-3 pr-4 font-medium">Пользователь</th>
            <th className="text-left py-3 pr-4 font-medium">Тариф</th>
            <th className="text-left py-3 pr-4 font-medium">Окончание пробного периода</th>
            <th className="text-left py-3 font-medium">Автопродление</th>
          </tr></thead>
          <tbody>{trials.map(user => <tr key={user.user_id || user.email} style={{ borderBottom: `1px solid ${theme.border}` }}>
            <td className="py-3 pr-4 align-top"><button type="button" className="admin-user-link break-all" style={{ color: theme.text }}
              onClick={() => onSelectUser(user)} aria-label={`Открыть пробную подписку ${user.email}`}>{user.email}</button>
              {user.is_internal && <div className="text-xs mt-1" style={{ color: theme.textSoft }}>Внутренний аккаунт</div>}
            </td>
            <td className="py-3 pr-4 align-top"><span className="inline-flex rounded-full px-2.5 py-1 text-xs font-medium" style={{ background: 'rgba(245,158,11,.12)', color: '#92400e' }}>{plans[user.plan_code] || user.plan_code}</span></td>
            <td className="py-3 pr-4 align-top whitespace-nowrap" style={{ color: theme.text }}>{dateLabel(user.trial_end)}</td>
            <td className="py-3 align-top" style={{ color: theme.textSoft }}>{user.auto_renew_enabled ? 'Включено' : 'Отключено'}</td>
          </tr>)}</tbody>
        </table></div>}
    </section>
  </Card>;
}
